import { Box, Typography } from '@mui/material';
import React from 'react';
import '../../../css/articleFolder/publicArticleFolder.css';

const PublicArticleFolderPageHeader = ({articleFolderTitle}) => {

    return (
        <Box className='publicArticleFolder_header'>
            <Typography className='publicArticleFolder_pageTitle'>{articleFolderTitle}</Typography>
        </Box>
    );
};

export default React.memo(PublicArticleFolderPageHeader);